module.exports = __webpack_public_path__ + "img/patuah_yes.158779a1.png";